import { ProductionOverviewCountMode } from 'models/production-overview';
import { escapeHtml, printTable, Translate } from './print-production-overview-orders';
import {
    OverviewCalendarGroup,
    getDayOfMonthLabel,
    getGroupHeaderCount,
    getRowCount,
    getWeekdayLabel,
} from './production-overview-utils';

const countCell = (count: number): string => `<td class="count">${count > 0 ? count : ''}</td>`;

/** DD-3880: prints the calendar as shown — same rows, period and Orders|Actions mode. */
export const printProductionOverviewCalendar = (
    groups: OverviewCalendarGroup[],
    days: string[],
    countMode: ProductionOverviewCountMode,
    title: string,
    translate: Translate,
): void => {
    const headers = [
        `<th>${escapeHtml(translate('production-overview:CALENDAR_FIRST_COLUMN'))}</th>`,
        ...days.map(
            (dayKey) =>
                `<th class="count">${escapeHtml(getWeekdayLabel(dayKey))}<br/>${escapeHtml(getDayOfMonthLabel(dayKey))}</th>`,
        ),
    ];

    const rows = groups
        .map((group) => {
            const groupCells = days
                .map((dayKey) =>
                    group.showDayTotals ? countCell(getGroupHeaderCount(group, dayKey, countMode)) : '<td></td>',
                )
                .join('');
            const groupRow = `<tr class="group"><td>${escapeHtml(translate(`production-overview:${group.labelKey}`))}</td>${groupCells}</tr>`;
            const subRows = group.rows.map((row) => {
                const cells = days.map((dayKey) => countCell(getRowCount(row, dayKey, countMode))).join('');
                return `<tr><td class="sub-row">${escapeHtml(translate(`production-overview:${row.labelKey}`))}</td>${cells}</tr>`;
            });
            return [groupRow, ...subRows].join('');
        })
        .join('');

    printTable(
        title,
        headers,
        rows,
        `th.count, td.count { text-align: center; padding: 4px 2px; }
        tr.group td { font-weight: bold; background: #f7f7f7; }
        td.sub-row { padding-left: 20px; white-space: nowrap; }
        @page { size: landscape; }`,
    );
};
